export interface ReportTemplate {
  id: string;
  name: string;
  clientLogo?: string; // Base64 o URL - Logo del cliente
  primaryColor: string;
  secondaryColor: string;
  headerText: string;
  footerText: string;
  sections: {
    summary: boolean;
    charts: boolean;
    topCategories: boolean;
    detailedList: boolean;
    photos: boolean;
    insights: boolean;
  };
  createdAt: string;
}

// Logo de Seprovinsa (siempre presente)
export const SEPROVINSA_LOGO = '/logo.png';

export interface ReportConfig {
  id: string;
  name: string;
  emails: string[];
  frequency: 'weekly' | 'monthly' | 'quarterly' | 'manual';
  dayOfWeek?: number; // 0-6 (Domingo-Sábado)
  dayOfMonth?: number; // 1-31
  time: string; // "08:00"
  formats: ('pdf' | 'excel')[];
  templateId: string;
  active: boolean;
  lastSent?: string;
  createdAt: string;
}

export const DEFAULT_TEMPLATE: ReportTemplate = {
  id: 'default',
  name: 'Reporte Estándar Seprovinsa',
  clientLogo: undefined, // Sin logo de cliente por defecto
  primaryColor: '#1890ff', // Azul Ant Design
  secondaryColor: '#001529', // Azul oscuro
  headerText: 'Reporte de Incidencias',
  footerText: 'Servicios Estratégicos de Protección y Vigilancia Integral S. A. (Seprovinsa Security)',
  sections: {
    summary: true,
    charts: false, // Desactivar gráficos por defecto (no están en el PDF)
    topCategories: true,
    detailedList: true,
    photos: false,
    insights: true,
  },
  createdAt: new Date().toISOString(),
};
